var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208 32h-24v-8a8 8 0 00-16 0v8H88v-8a8 8 0 00-16 0v8H48a16 16 0 00-16 16v160a16 16 0 0016 16h160a16 16 0 0016-16V48a16 16 0 00-16-16zM72 48v8a8 8 0 0016 0v-8h80v8a8 8 0 0016 0v-8h24v32H48V48zm136 160H48V96h160v112zm-50.34-74.34L139.31 152l18.35 18.34a8 8 0 01-11.32 11.32L128 163.31l-18.34 18.35a8 8 0 01-11.32-11.32L116.69 152l-18.35-18.34a8 8 0 0111.32-11.32L128 140.69l18.34-18.35a8 8 0 0111.32 11.32z"
  })));
}

export default SvgCalendarx;